export default __webpack_public_path__ + "static/media/room-polen-4.3574af98.jpg";